/**
 * Countries Teamna does not serve. The web and mobile country pickers leave them out, and a typed or
 * linked number from one of them does not count as a valid number. ISO 3166-1 alpha-2 codes.
 */
export const UNSUPPORTED_COUNTRIES: readonly string[] = ["IL"];

/** True when Teamna serves this country, so it may show in a picker or carry a number. */
export function isSupportedCountry(code: string): boolean {
  return !UNSUPPORTED_COUNTRIES.includes(code.toUpperCase());
}
